/**
 * Fiscal Receipts schema — фискальные чеки (multi-provider).
 *
 * Хранит lifecycle фискализации для каждой операции (приход/возврат/коррекция)
 * по каждому заказу. Провайдер — CloudPayments или Бизнес.ру.
 *
 * Источник правды миграции: drizzle/0103_fiscal_receipts.sql.
 */
import {
  index,
  integer,
  jsonb,
  numeric,
  pgEnum,
  pgTable,
  serial,
  text,
  timestamp,
  uniqueIndex,
} from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { order } from './commerce';

export const fiscalProvider = pgEnum('FiscalProvider', [
  'CLOUDPAYMENTS',
  'BUSINESS_RU',
]);

export const fiscalOperation = pgEnum('FiscalOperation', [
  'SELL',
  'REFUND',
  'CORRECTION_SELL',
  'CORRECTION_REFUND',
]);

export const fiscalReceiptStatus = pgEnum('FiscalReceiptStatus', [
  'PENDING',
  'SENT',
  'SUCCESS',
  'FAILED',
]);

export const fiscalReceipt = pgTable(
  'FiscalReceipt',
  {
    id: serial('id').primaryKey(),
    orderId: integer('orderId')
      .notNull()
      .references(() => order.id, { onDelete: 'cascade', onUpdate: 'cascade' }),
    provider: fiscalProvider('provider').notNull(),
    operation: fiscalOperation('operation').notNull(),
    status: fiscalReceiptStatus('status').default('PENDING').notNull(),

    /** MC-<orderId>-<operation>[-attempt]. UNIQUE с provider. */
    idempotencyKey: text('idempotencyKey').notNull(),

    /** ID операции у провайдера (CloudPayments transactionId / Бизнес.ру command_id). */
    externalCommandId: text('externalCommandId'),

    /** Тег 1077 — фискальный признак. */
    fiscalSign: text('fiscalSign'),
    /** Тег 1040 — номер ФД. */
    fiscalDocNumber: integer('fiscalDocNumber'),
    fiscalDocDate: timestamp('fiscalDocDate', { precision: 3, mode: 'date' }),
    fnNumber: text('fnNumber'),
    kktRegNumber: text('kktRegNumber'),
    shiftNumber: integer('shiftNumber'),
    fiscalReceiptNumber: integer('fiscalReceiptNumber'),

    amount: numeric('amount', { precision: 18, scale: 2 }).notNull(),
    currency: text('currency').notNull(),

    rawRequest: jsonb('rawRequest'),
    rawResponse: jsonb('rawResponse'),

    attempts: integer('attempts').default(0).notNull(),
    lastError: text('lastError'),

    createdAt: timestamp('createdAt', { precision: 3, mode: 'date' })
      .default(sql`CURRENT_TIMESTAMP`)
      .notNull(),
    updatedAt: timestamp('updatedAt', { precision: 3, mode: 'date' })
      .$onUpdate(() => new Date())
      .notNull(),
  },
  (table) => [
    uniqueIndex('FiscalReceipt_provider_idempotencyKey_idx').on(
      table.provider,
      table.idempotencyKey,
    ),
    index('FiscalReceipt_orderId_idx').on(table.orderId),
    index('FiscalReceipt_status_provider_idx').on(table.status, table.provider),
    index('FiscalReceipt_fiscalSign_idx')
      .on(table.fiscalSign)
      .where(sql`"fiscalSign" IS NOT NULL`),
  ],
);
